import { useState, useRef } from 'react';
import { observer } from 'mobx-react';
import { useMobxStores } from '@stores/store';
import { isEmpty as _isEmpty } from 'lodash';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper';
import { useNavigate } from 'react-router-dom';

import useShrink from '@hook/useShrink';
import { useWindowSize } from 'usehooks-ts';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import '@style/MainBannerSlide.scss';

import ImageBanner from '@organisms/main/partial/ImageBanner';
import YoutubeBanner from '@organisms/main/partial/YoutubeBanner';
import VideoBanner from '@organisms/main/partial/VideoBanner';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';

const SlideNextButton = ({ onClickSlideBtn }) => {
  return (
    <button onClick={() => onClickSlideBtn('next')} className="h-full">
      <img src="/img/slider-arrow.svg" alt="" className="h-full !w-auto" />
    </button>
  );
};
const SlidePrevButton = ({ onClickSlideBtn }) => {
  return (
    <button onClick={() => onClickSlideBtn('prev')} className="h-full">
      <img src="/img/slider-arrow.svg" alt="" className="h-full !w-auto" />
    </button>
  );
};

const MainBannerSlide = () => {
  const { mainStore } = useMobxStores();

  const [onPlay, setOnPlay] = useState(false);
  const [currentVideoRef, setCurrentVideoRef] = useState(null);
  const [currentYoutubeRef, setCurrentYoutubeRef] = useState(null);
  const swiperRef = useRef(null);

  const { width } = useWindowSize();
  useShrink(width > 1280 ? 720 : 100);
  const navigate = useNavigate();

  let visualStyle = isMobileWithOutIpad() ? 'pt-[153.6%]' : 'pt-[56.25%]';

  const onClickSlideBtn = type => {
    if (type === 'next') {
      swiperRef.current?.swiper.slideNext();
    } else if (type === 'prev') {
      swiperRef.current?.swiper.slidePrev();
    }
  };

  return (
    <div className="relative">
      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        speed={1400}
        slidesPerView={1}
        spaceBetween={0}
        loop
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        threshold={100}
        className="mainBannerSlider bg-[#fff] "
        ref={swiperRef}
        pagination={{ clickable: true }}
        onActiveIndexChange={swiper => {
          setOnPlay(false);
          if (!_isEmpty(currentVideoRef)) {
            currentVideoRef.current?.pause();
            currentVideoRef.current.currentTime = 0;
            swiper.autoplay.start();
          }
          if (!_isEmpty(currentYoutubeRef)) {
            currentYoutubeRef.seekTo(0);
            currentYoutubeRef.pauseVideo();
            swiper.autoplay.start();
          }
        }}
      >
        {!_isEmpty(mainStore.keyvisualList) &&
          !_isEmpty(mainStore.keyvisualList.contents) &&
          mainStore.keyvisualList.contents.map((row, index) => {
            if (row.type === 'image' && !_isEmpty(row.imageSrc)) {
              let mImage = _isEmpty(row.moImageSrc)
                ? row.imageSrc
                : row.moImageSrc;
              return (
                <SwiperSlide key={`main_banner_${index}`}>
                  <ImageBanner data={row} navigate={navigate} />
                  <div
                    className={`w-full block h-auto relative overflow-hidden ${visualStyle} "`}
                  >
                    <img
                      src={`${isMobileWithOutIpad() ? mImage : row.imageSrc}`}
                      className="object-cover block w-full max-h-full top-0 left-0  absolute"
                    />
                  </div>
                </SwiperSlide>
              );
            } else if (
              row.type === 'video' &&
              row.checkLink === 'N' &&
              !_isEmpty(row.videoSrc)
            ) {
              return (
                <SwiperSlide key={`main_banner_${index}`}>
                  <VideoBanner
                    data={row}
                    onPlay={onPlay}
                    setOnPlay={setOnPlay}
                    setCurrentVideoRef={setCurrentVideoRef}
                  />
                </SwiperSlide>
              );
            } else if (
              row.type === 'video' &&
              row.checkLink === 'Y' &&
              !_isEmpty(row.youtubeUrl)
            ) {
              return (
                <SwiperSlide key={`main_banner_${index}`}>
                  <YoutubeBanner
                    data={row}
                    onPlay={onPlay}
                    setOnPlay={setOnPlay}
                    setCurrentYoutubeRef={setCurrentYoutubeRef}
                  />
                </SwiperSlide>
              );
            }
          })}
        <div className="absolute h-[37px] xl:h-[60px] right-0 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <SlideNextButton onClickSlideBtn={onClickSlideBtn} />
        </div>
        <div className="absolute h-[37px] xl:h-[60px] left-0 rotate-180 top-1/2 translate-x-1/2 -translate-y-1/2 z-10">
          <SlidePrevButton onClickSlideBtn={onClickSlideBtn} />
        </div>
      </Swiper>
      <div className="h-[57px] absolute bottom-[80px] left-1/2 -translate-x-1/2 z-10 hidden xl:block">
        <img
          alt=""
          src="/img/icon-scroll.png"
          srcSet="/img/icon-scroll@2x.png 2x,
              /img/icon-scroll@3x.png 3x"
        />
      </div>
    </div>
  );
};

export default observer(MainBannerSlide);
